import React, { useState } from 'react';

const RecipeModal = ({ isOpen, onClose }) => {
  const [selectedRecipe, setSelectedRecipe] = useState('focaccia');

  const recipes = {
    focaccia: {
      name: "Nonna's Focaccia",
      difficulty: "Easy",
      time: "3 hours (including rise time)",
      serves: "8-10 people",
      ingredients: [
        "4 cups (500g) bread flour",
        "1½ cups (350ml) warm water",
        "2 tsp active dry yeast",
        "2 tsp salt",
        "¼ cup (60ml) extra virgin olive oil",
        "Fresh rosemary sprigs",
        "Coarse sea salt for topping",
        "Optional: cherry tomatoes, olives"
      ],
      instructions: [
        "Dissolve yeast in warm water and let sit for 5 minutes until foamy.",
        "In a large bowl, combine flour and salt. Add yeast mixture and 2 tbsp olive oil.",
        "Mix until a shaggy dough forms, then knead for 8-10 minutes until smooth.",
        "Place in oiled bowl, cover, and let rise for 1-2 hours until doubled.",
        "Transfer to oiled 9x13 pan, stretch to fit, and let rise 30 minutes.",
        "Dimple surface with fingers, drizzle with remaining oil, add toppings.",
        "Bake at 425°F (220°C) for 25-30 minutes until golden brown.",
        "Cool slightly before cutting. Serve warm or at room temperature."
      ],
      tips: [
        "Use high-quality olive oil for the best flavor",
        "Don't skip the second rise - it creates the airy texture",
        "Wet your fingers when dimpling to prevent sticking"
      ]
    },
    pasta: {
      name: "Fresh Egg Pasta",
      difficulty: "Medium",
      time: "1 hour",
      serves: "4-6 people",
      ingredients: [
        "3 cups (375g) 00 flour or all-purpose flour",
        "4 large eggs",
        "1 tbsp olive oil",
        "1 tsp salt",
        "Semolina flour for dusting"
      ],
      instructions: [
        "Make a well with flour on a clean surface, crack eggs in center.",
        "Add oil and salt to eggs, whisk with a fork gradually incorporating flour.",
        "Knead dough for 10 minutes until smooth and elastic.",
        "Wrap in plastic and rest for 30 minutes at room temperature.",
        "Roll out thin using pasta machine or rolling pin.",
        "Cut into desired shapes (fettuccine, tagliatelle, etc.).",
        "Cook in salted boiling water for 2-3 minutes until al dente.",
        "Serve immediately with your favorite sauce."
      ],
      tips: [
        "The dough should be firm but not dry",
        "Resting is crucial for workable dough",
        "Fresh pasta cooks much faster than dried"
      ]
    },
    sauce: {
      name: "Sunday Gravy (Tomato Sauce)",
      difficulty: "Easy",
      time: "2-4 hours",
      serves: "6-8 people",
      ingredients: [
        "2 cans (28oz each) San Marzano tomatoes",
        "6 cloves garlic, sliced thin",
        "½ cup extra virgin olive oil",
        "1 large onion, diced",
        "Fresh basil leaves",
        "Salt and black pepper to taste",
        "1 tsp sugar (optional)",
        "Red pepper flakes (optional)"
      ],
      instructions: [
        "Heat olive oil in large pot over medium heat.",
        "Sauté onion until translucent, about 5 minutes.",
        "Add garlic and cook until fragrant, about 1 minute.",
        "Crush tomatoes by hand and add to pot with their juice.",
        "Season with salt, pepper, and red pepper flakes.",
        "Simmer on low heat for 2-4 hours, stirring occasionally.",
        "Add fresh basil in the last 30 minutes.",
        "Taste and adjust seasoning before serving."
      ],
      tips: [
        "Low and slow cooking develops the best flavor",
        "San Marzano tomatoes make a difference",
        "Add a parmesan rind while simmering for extra depth"
      ]
    }
  };

  if (!isOpen) return null;

  const recipe = recipes[selectedRecipe];

  return (
    <div className="recipe-modal">
      <div className="recipe-content">
        <div className="recipe-header">
          <h2>Family Recipes</h2>
          <button onClick={onClose} className="close-btn">×</button>
        </div>
        
        <div className="recipe-tabs">
          {Object.entries(recipes).map(([key, r]) => (
            <button
              key={key}
              className={`recipe-tab ${selectedRecipe === key ? 'active' : ''}`}
              onClick={() => setSelectedRecipe(key)}
            >
              {r.name}
            </button>
          ))}
        </div>

        <div className="recipe-body">
          <div className="recipe-info">
            <h3>{recipe.name}</h3>
            <div className="recipe-meta">
              <span className="difficulty">
                <i className="fas fa-chart-bar"></i>
                {recipe.difficulty}
              </span>
              <span className="time">
                <i className="fas fa-clock"></i>
                {recipe.time}
              </span>
              <span className="serves">
                <i className="fas fa-users"></i>
                {recipe.serves}
              </span>
            </div>
          </div>

          <div className="recipe-sections">
            <div className="ingredients-section">
              <h4>Ingredients</h4>
              <ul className="ingredients-list">
                {recipe.ingredients.map((ingredient, index) => (
                  <li key={index}>{ingredient}</li>
                ))}
              </ul>
            </div>

            <div className="instructions-section">
              <h4>Instructions</h4>
              <ol className="instructions-list">
                {recipe.instructions.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
            </div>

            <div className="tips-section">
              <h4>Nonna's Tips</h4>
              <ul className="tips-list">
                {recipe.tips.map((tip, index) => (
                  <li key={index}>
                    <i className="fas fa-lightbulb"></i>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipeModal;
